import type { Router } from "vue-router";

// Holds the router instance once it is created. Provides a dependency-free
// import point so that urlParams.ts (and similar sync utilities) can access
// the router without pulling router.ts into their static import chain, which
// would create a routes.ts → linkFactories → urlParams → router.ts → routes.ts
// circular dependency and a TDZ error in Nuxt's ESM evaluation order.
export let routerRef: Router | undefined;

let markRouterReady: ((router: Router) => void) | undefined;

// Under Nuxt, routerRef is set from App.vue's setup, which runs only after the initial navigation
// (and every guard on it) has already resolved. Code reached from those guards — the afterLogin()
// chain behind startupUserCheck — therefore cannot assume the router is already there. Awaiting
// this inside a guard would deadlock (mount waits for the navigation), so it is meant to be
// chained onto, not awaited.
const routerReady = new Promise<Router>((resolve) => {
  markRouterReady = resolve;
});

export function setRouterRef(router: Router): void {
  routerRef = router;
  markRouterReady?.(router);
}

export function whenRouterReady(): Promise<Router> {
  return routerReady;
}
